// global Calendly

import React, { Component } from "react"
import PropTypes from "prop-types"
import queryString from "query-string"
import SbEditable from "storyblok-react"

import { addCookieData } from "../../helpers/handleCookies"

const $script = typeof document !== "undefined" ? require("scriptjs") : null

function isCalendlyEvent(e) {
  return e.data.event && e.data.event.indexOf("calendly") === 0
}

class CalendlyForm extends Component {
  state = {
    loading: true,
    timeSelected: false,
    contact: null,
    iFrameHeight: 0,
    calendlyUrl: "",
  }

  componentDidMount() {
    if (window) {
      window.addEventListener("message", this.checkCalendlyEvent)
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S
      const { calendly } = queryParams

      const calendlyUrl = calendly
        ? decodeURIComponent(calendly)
        : this.props.blok.calendly_link

      if (contactId) {
        fetch(
          `${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
          {
            method: "post",
            body: JSON.stringify({ contactID: contactId }),
          }
        )
          .then((resp) => {
            return resp.json()
          })
          .then((data) => {
            this.setState(
              {
                contact: JSON.parse(data),
                calendlyUrl: calendlyUrl,
              },
              () => {
                this.setCalendlyScript(
                  this.state.contact.FirstName,
                  this.state.contact.LastName,
                  calendlyUrl
                )
              }
            )
          })
          .catch((err) => {
            console.log(err)
            this.setState(
              {
                calendlyUrl: calendlyUrl,
              },
              () => this.setCalendlyScript("", "", calendlyUrl)
            )
          })
      } else {
        this.setState(
          {
            calendlyUrl: calendlyUrl,
          },
          () => this.setCalendlyScript("", "", calendlyUrl)
        )
      }
    }
  }

  setCalendlyScript = (firstName = "", lastName = "", calendlyUrl) => {
    if ($script)
      $script("https://assets.calendly.com/assets/external/widget.js", () => {
        const Calendly = window.Calendly
        const cookieData = addCookieData()
        const contentAttribution = {
          GATRACKID: cookieData.GATRACKID ? cookieData.GATRACKID : "",
          GAUSERID: cookieData.GAUSERID ? cookieData.GAUSERID : "",
          GACLIENTID: cookieData.GACLIENTID ? cookieData.GACLIENTID : "",
          jobID: cookieData.pillarEmailJobId,
          utm_content: cookieData.firstwebContent,
        }
        const calendlyTitle = calendlyUrl
          .split("?")[0]
          .split("/")[4]
          .replace(/-/g, " ")

        const encodedStr = encodeURIComponent(
          JSON.stringify(contentAttribution)
        )

        Calendly.initInlineWidget({
          url: `${calendlyUrl}`,
          parentElement: this.instance,
          prefill: {
            firstName,
            lastName,
          },
          utm: {
            utmCampaign: this.slice(cookieData.firstwebCampaign),
            utmSource: this.slice(cookieData.firstpartnerCode),
            utmMedium: this.slice(cookieData.firstwebMedium),
            utmContent: this.slice(encodedStr),
            utmTerm: this.slice(cookieData.firstwebTerm),
          },
        })
        this.eventToDataLayer("event_page_viewed", calendlyTitle)
      })
  }

  slice = (str) => {
    return str && str.length > 255 ? str.slice(0, 255) : str;
  }

  getIframeHeight = () => {
    const iframe = document.getElementsByTagName("iframe")[0]
    if (iframe) {
      this.setState({
        iFrameHeight: iframe.contentWindow.frames.parent.innerHeight,
      })
    }
  }

  checkCalendlyEvent = (e) => {
    if (isCalendlyEvent(e)) {
      const { calendlyUrl } = this.state
      const calendlyTitle = calendlyUrl
        .split("?")[0]
        .split("/")[4]
        .replace(/-/g, " ")
      const { data } = e

      let eventAction = ""

      switch (data.event) {
        case "calendly.profile_page_viewed":
          eventAction = "profile_viewed"
          break
        case "calendly.date_and_time_selected":
          this.setState({ timeSelected: true })
          eventAction = "event_date_time_selected"
          break
        case "calendly.event_type_viewed":
          this.setState({ loading: false })
          eventAction = "event_calendar_viewed"
          break
        case "calendly.event_scheduled":
          eventAction = "event_registration"
          break
        default:
          break
      }
      this.eventToDataLayer(eventAction, calendlyTitle)
    }
    this.getIframeHeight()
  }

  eventToDataLayer = (event, label) =>
    window.dataLayer.push({
      event: "calendlyEvent",
      calendlyEvent: event,
      calendlyLabel: label,
    })

  render = () => (
    <SbEditable content={this.props.blok}>
      <div
        className={`calendly-container ${this.state.loading ? "fs-wrapper--loading" : ""}`}
      >
        <div
          style={{ height: this.state.iFrameHeight }}
          className={[
            "calendly-form",
            `${this.state.loading ? "" : "calendly-form--visible"}`,
            `${this.state.timeSelected ? "calendly-form--form-step" : ""}`,
          ].join(" ")}
          ref={(el) => (this.instance = el)}
        />
      </div>
    </SbEditable>
  )
}

CalendlyForm.propTypes = {
  blok: PropTypes.shape({
    calendly_link: PropTypes.string.isRequired,
  }),
}

export default CalendlyForm
